var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.63934 13.8115C2.9694 15.0954 3.19609 16.5004 3.91707 17.4719C4.64197 18.4486 5.91606 19.0375 7.29303 18.573L9.52548 17.8198L11.0388 12.2098C11.3056 11.2208 12.7102 11.2249 12.9713 12.2154L14.4534 17.8384L16.6686 18.6001C18.0429 19.0726 19.3203 18.491 20.0509 17.5185C20.7774 16.5512 21.0123 15.1475 20.3497 13.8597L14.7461 2.96717C13.5719 0.684699 10.4932 0.675796 9.30586 2.95145L3.63934 13.8115ZM12.7476 17.2519L11.9987 14.4108L11.2347 17.2431L11.5213 17.1464C11.8241 17.0443 12.1464 17.0452 12.4487 17.1491L12.7476 17.2519Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.97652 19.9912L8.97363 20.9912",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9765 20.0085L14.9736 21.0085",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9794 19L11.9707 22",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.76beb874f41800aba4dafd10006ba605.svg";
export { ForwardRef as ReactComponent };